module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.71ad32ce.svg";